export type StoryBook = {
    id: string;
    title: string;
    description: string;
    public: boolean;
    storyPath: string;
    tags: string[];
};



const StoryBooks: StoryBook[] = [
    {
        id: "keeping_warm",
        title: "Keeping warm",
        description: "After an exhilarating day snowboarding alone due to her best friend's flu, 29-year-old Mia returns to her cozy ski lodge. Seeking warmth from cocoa and a fire, she lounges on a bear rug, her mind drifting to steamy fantasies involving rugged men and playful women from the slopes. What starts as idle thoughts escalates into an intense night of solo exploration, where she masturbates repeatedly, experimenting with her body in vivid, uninhibited pleasure until exhaustion claims her.",
        public: true,
        storyPath: "/bookdata/erotica/keeping_warm.txt",
        tags: ["Snow","NSFW MiniJam Story","Solo","Masturbation","Solitude","Improvised Sex Toys","Object Insertion"]
    },
    {
        id: "matter_of_discipline",
        title: "A matter of Discipline",
        description: "Two unruly students break into their principals office. As they are about to get busted, one flees, the other stays. And the one staying quickly becomes engulfed in new lessons with various props.",
        public: true,
        storyPath: "/bookdata/erotica/matter_of_discipline.txt",
        tags: ["Teacher/Student","FMM","Power Dynamics","Boarding School Taboo","Coerced BDSM","Sex Toys","Sex Toy Overload","First-Person"]
    },
    {
        id: "ravaged_by_the_raider",
        title: "Ravaged by the Raider",
        description: "In a windswept Viking village, Astrid paces her hut, body aching for her warrior husband Ulf's return from the raid. She ignores doubts from other wives, denying her urges to save them for his touch. As longships roar into dock, their eyes lock, igniting a savage hunger that drives them inside. What erupts is brutal, primal sex; crashing against walls, fucking amid bites of roasted chicken, collapsing in spent ecstasy.",
        public: true,
        storyPath: "/bookdata/erotica/ravaged_by_the_raider.txt",
        tags: ["Snow","NSFW MiniJam Story","MF", "Vikings", "Historic", "Food-play","Rough Sex","Hairy","Animalistic","Reunion"]
    },
    {
        id: "tiny",
        title: "Tiny Test Story",
        description: "Just a story.",
        public: false,
        storyPath: "/bookdata/erotica/tinystory.txt",
        tags: [""]
    },
    {
        id: "redder_better",
        title: "Redder is better",
        description: "A collection of stories about keeping warm in the cold winter months.",
        public: false,
        storyPath: "/bookdata/erotica/keeping_warm.txt",
        tags: [""]
    },
    {
        id: "vanilla_cream",
        title: "Vanilla Cream",
        description: "A collection of stories about keeping warm in the cold winter months.",
        public: false,
        storyPath: "/public/bookdata/erotica/keeping_warm.txt",
        tags: [""]
    },
    {
        id: "even_more",
        title: "Even More",
        description: "A collection of stories about keeping warm in the cold winter months.",
        public: false,
        storyPath: "/public/bookdata/erotica/keeping_warm.txt",
        tags: [""]
    },
    ];

export default StoryBooks